




























































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios from "axios";
import { Dialog } from "buefy";

@Component
export default class Importer extends Vue {

    formData = new FormData();
    formData1 = new FormData();

    isCSVSubmitting: boolean = false;
    submitCSVResult: boolean = false;
    isCSVSubmitted: boolean = false;
    showCSVError: boolean = false;
    importCSVDisabled: boolean = true;

    isTaxonomySubmitting: boolean = false;
    submitTaxonomyResult: boolean = false;
    isTaxonomySubmitted: boolean = false;
    showTaxonomyError: boolean = false;

    isFirstReleaseSubmitting: boolean = false;
    submitFirstReleaseResult: boolean = false;
    isFirstReleaseSubmitted: boolean = false;
    showFirstReleaseError: boolean = false;

    isTaxonomyMediaSubmitting: boolean = false;
    submitTaxonomyMediaResult: boolean = false;
    isTaxonomyMediaSubmitted: boolean = false;
    showTaxonomyMediaError: boolean = false;

    isDeleteStarted: boolean = false;
    deleteYearResult: boolean = false;
    isDeleteSuccessful: boolean = false;
    showDeleteError: boolean = false;

    source: any = {};
    isCancelled: boolean = false;
    file: string = '';
    year: string = '0';
    taxonomyYear: string = '0';
    taxonomyMediaYear: string = '0';
    umbracoId: string = '0';
    firstReleasesYear: string = '0';
    firstReleasesUmbracoId: string = '0';
    romanYear: string = '';



    async mounted() {

    }

    async submit() {
        this.resetNotifications();
        this.isCSVSubmitting = true;
        this.formData.delete('csvDocument');
        this.formData.delete('year');
        this.formData.append('csvDocument', this.file);
        this.formData.append('year', this.year);
        try {
            await axios.post(
                `/import/calendar`,
                this.formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                        'Content-Type': 'multipart/form-data'
                    },
                }
            );
            this.isCSVSubmitting = false;
            this.isCSVSubmitted = true;
            this.submitCSVResult = true;
        } catch {
            this.isCSVSubmitting = false;
            this.isCSVSubmitted = false;
            this.submitCSVResult = false;
            this.showCSVError = true;
        }
    }

    async submitTaxonomy() {
        this.resetNotifications();
        this.isTaxonomySubmitting = true;
        this.formData.delete('umbracoNodeId');
        this.formData.delete('taxonomyYear');
        this.formData.append('umbracoNodeId', this.umbracoId);
        this.formData.append('taxonomyYear', this.taxonomyYear);
        try {
            await axios.post(
                `/first-release/GenerateTaxonomyForFirstReleasesInUmbraco`,
                this.formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.token
                    },
                }
            );
            this.isTaxonomySubmitting = false;
            this.isTaxonomySubmitted = true;
            this.submitTaxonomyResult = true;
        } catch {
            this.isTaxonomySubmitting = false;
            this.isTaxonomySubmitted = false;
            this.submitTaxonomyResult = false;
            this.showTaxonomyError = true;
        }
    }

    async submitTaxonomyMedia() {
        this.resetNotifications();
        this.isTaxonomyMediaSubmitting = true;
        this.formData.delete('taxonomyYear');
        this.formData.append('taxonomyYear', this.taxonomyMediaYear);
        try {
            await axios.post(
                `/first-release/GenerateMediaFoldersStructure`,
                this.formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.token
                    },
                }
            );
            this.isTaxonomyMediaSubmitting = false;
            this.isTaxonomyMediaSubmitted = true;
            this.submitTaxonomyMediaResult = true;
        } catch {
            this.isTaxonomyMediaSubmitting = false;
            this.isTaxonomyMediaSubmitted = false;
            this.submitTaxonomyMediaResult = false;
            this.showTaxonomyMediaError = true;
        }
    }

    async submitFirstReleases() {
        this.resetNotifications();
        this.isFirstReleaseSubmitting = true;
        this.formData1.delete('umbracoNodeId');
        this.formData1.delete('firstReleasesYear');
        this.formData1.delete('romanYear');
        this.formData1.append('umbracoNodeId', this.firstReleasesUmbracoId);
        this.formData1.append('firstReleasesYear', this.firstReleasesYear);
        this.formData1.append('romanYear', this.romanYear);
        try {
            await axios.post(
                `/import/calendar/umbraco`,
                this.formData1,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.token
                    },
                }
            );
            this.isFirstReleaseSubmitting = false;
            this.isFirstReleaseSubmitted = true;
            this.submitFirstReleaseResult = true;
        } catch {
            this.isFirstReleaseSubmitting = false;
            this.isFirstReleaseSubmitted = false;
            this.submitFirstReleaseResult = false;
            this.showFirstReleaseError = true;
        }
    }

    handleFileUpload(event) {
        this.file = event.target.files[0];
    }

    handleYearEntry(event) {
        this.year = event.target.value;
    }

    handleTaxonomyYearEntry(event) {
        this.taxonomyYear = event.target.value;
    }

    handleUmbracoIdEntry(event) {
        this.umbracoId = event.target.value;
    }

    GoBack() {
        this.$router.go(-1);
    }

    formatter(d) {
        return d.toLocaleDateString();
    }

    resetNotifications() {
        this.isCSVSubmitting = false;
        this.submitCSVResult = false;
        this.showCSVError = false;

        this.isTaxonomySubmitting = false;
        this.submitTaxonomyResult = false;
        this.showTaxonomyError = false;

        this.isFirstReleaseSubmitting = false;
        this.submitFirstReleaseResult = false;
        this.showFirstReleaseError = false;

        this.isTaxonomyMediaSubmitting = false;
        this.submitTaxonomyMediaResult = false;
        this.showTaxonomyMediaError = false;

        this.isDeleteStarted = false;
        this.deleteYearResult = false;
        this.isDeleteSuccessful = false;
        this.showDeleteError = false;
    }

    async prompt() {
        this.$dialog.prompt(
            {
                message: `Upišite godinu koju želite obrisati?`,
                inputAttrs: {
                    type: 'number',
                    placeholder: 'Godina kalendara',
                    value: '',
                    min: 2022,
                    max: 2050
                },
                confirmText: "Potvrdi",
                cancelText: "Odustani",
                onConfirm: async (value) => await this.deleteDocumentsYear(value)
            }
        )
    }

    async deleteDocumentsYear(documentsYear) {
        this.resetNotifications();
        this.isDeleteStarted = true;
        try {
            await axios.delete(
                `/document/deleteyear/${parseInt(documentsYear)}`,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
            );
            this.isDeleteStarted = false;
            this.deleteYearResult = true;
            this.isDeleteSuccessful = true;
        } catch (err) {
            this.isDeleteStarted = false;
            this.deleteYearResult = false;
            this.isDeleteSuccessful = false;
            this.showDeleteError = true;
        }
    }

}
